import { baseUrl } from '@/service/util';
import request from '@/utils/request';
import { setLocaleQuery } from '@/utils';
import { CookieDataExtendType } from '@/utils/cookies/type';
import { subscribeCookie } from 'eco-design-reliance/cookies/subscribeCookie';

// 提交邮箱订阅
export const submitScribe = (locale: string, data: any, subscribeData?: CookieDataExtendType) => {
    return request.post(`${baseUrl(locale)}/subscribe/new${setLocaleQuery(locale)}`, {
        data: subscribeData ? { ...data, eventTracking: subscribeCookie(subscribeData) } : data,
    });
};
